window.addEventListener( 'load', function() {

	function toggleFAQItem( button ) {
		const faqContent = document.getElementById( button.getAttribute( 'aria-controls' ) );
		if ( faqContent ) {
			const parent = button.closest( '.faq-item' );
			if ( 'false' === button.getAttribute( 'aria-expanded' ) ) {
				button.setAttribute( 'aria-expanded', true );
				faqContent.removeAttribute( 'hidden' );
				parent.classList.add( 'faq-item--active' );
			} else {
				button.setAttribute( 'aria-expanded', false );
				faqContent.setAttribute( 'hidden', '' );
				parent.classList.remove( 'faq-item--active' );
			}
		}
	}

	// Open first faq item in each FAQ elements
	const faqItems = this.document.querySelectorAll( '.faq' );
	[...faqItems].forEach( faqItem => {
		const firstButton = faqItem.querySelector( '.faq-item__button' );
		if ( firstButton ) {
			toggleFAQItem( firstButton );
		}		
	} );

	const faqItemsButtons = document.querySelectorAll( '.faq-item__button' );
	[...faqItemsButtons].forEach( faqItemButton => {
		faqItemButton.addEventListener( 'click', e => {
			e.preventDefault();
			toggleFAQItem( faqItemButton );
		} );
	} );

} );